// extracted by mini-css-extract-plugin
export default {"container":"FullscreenContent_container__R46Ka","close":"FullscreenContent_close__xgLuF"};